var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import APIMap from "../api_map.js";
import axios from "axios";
import getIP from "../getIP.js";
const IP = getIP();
export function getAllPaymentProviders(_a) {
    return __awaiter(this, arguments, void 0, function* ({ queryKey }) {
        const config = {
            headers: {
                Authorization: `Bearer ${queryKey[1]}`,
            },
        };
        let url = IP + APIMap("getAllPaymentProviders");
        let response = yield axios.get(url, config);
        return response;
    });
}
export function getPaymentProviderById(options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        var url = IP + APIMap("getPaymentProviderById");
        url = url.replace("{id}", options.id);
        const config = {
            headers: {
                Authorization: `Bearer ${(_a = options.userDetails) === null || _a === void 0 ? void 0 : _a.token}`,
            },
        };
        let response = yield axios.post(url, options.payload, config);
        return response;
    });
}
export function requestPayment(url, token, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        url = IP + url;
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let response = yield axios.post(url, payload, config);
        return response;
    });
}
export function checkPaymentStatus(token, txnId) {
    return __awaiter(this, void 0, void 0, function* () {
        let url = IP + APIMap("checkPaymentStatus");
        url = url.replace("{txnId}", txnId);
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let response = yield axios.get(url, config);
        return response;
    });
}
export function fetchPaymentStatus(url, token, txnId) {
    return __awaiter(this, void 0, void 0, function* () {
        url = IP + url;
        url = url.replace("{transactionId}", txnId);
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let response = yield axios.get(url, config);
        return response;
    });
}
export function registrationAPIForEAnd(token, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const url = IP + APIMap("registrationForEAnd");
        let response = yield axios.post(url, payload, config);
        return response;
    });
}
export function finalizationAPIforEAnd(txnId, token) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = IP + APIMap("finalizationForEAnd");
        let config = null;
        if (token) {
            config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
        }
        const body = {
            txnId: txnId,
        };
        let response = null;
        if (token) {
            response = yield axios.post(url, body, config);
        }
        else {
            response = yield axios.post(url, body);
        }
        return response;
    });
}
